import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Popover from '../../base/popover/components/Popover.web';
import { SMALL_MOBILE_WIDTH } from '../../base/responsive-ui/constants';
import { getDesktopShareQualitySettingsVisibility } from "../../settings/functions.any";
import DesktopPickerQualityContent from "./DesktopPickerQualityContent";
import { toggleDesktopShareQualitySettings } from "../../settings/actions.web";
const useStyles = makeStyles()(() => {
    return {
        container: {
            display: 'inline-block',
            flexShrink: 0,
        }
    };
});
/**
 * Popup with desktop share quality settings.
 *
 * @returns {ReactElement}
 */
function DesktopPickerQualityPopup({ children, isOpen, onClose, popupPlacement, screenShareHint, onClick, }) {
    const { classes, cx } = useStyles();
    return (React.createElement("div", { className: classes.container },
        React.createElement(Popover, { allowClick: true, content: React.createElement(DesktopPickerQualityContent, { screenShareHint: screenShareHint, onClick: onClick }), headingId: 'desktop-share-quality-settings-button', onPopoverClose: onClose, position: popupPlacement, trigger: 'click', visible: isOpen }, children)));
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    const { clientWidth } = state['features/base/responsive-ui'];
    return {
        popupPlacement: clientWidth <= Number(SMALL_MOBILE_WIDTH) ? 'auto' : 'top-start_block',
        isOpen: Boolean(getDesktopShareQualitySettingsVisibility(state)),
    };
}
const mapDispatchToProps = {
    onClose: toggleDesktopShareQualitySettings,
};
export default connect(mapStateToProps, mapDispatchToProps)(DesktopPickerQualityPopup);
